var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "competition-settings rebates" },
    [
      !_vm.ready
        ? _c("div", { staticClass: "row mat32" }, [_vm._m(0)])
        : [
            _c(
              "panel-competition-form-box",
              { staticClass: "rebates-form__box mab16" },
              [
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-4" },
                  [
                    _c("p", { staticClass: "rebates-form__label" }, [
                      _vm._v("Generowanie kodów rabatowych"),
                    ]),
                    _c("panel-input-base-radio", {
                      attrs: {
                        name: "rebate-type",
                        option: { value: "price", title: "Rabat kwotowy" },
                      },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    }),
                    _c("panel-input-base-radio", {
                      attrs: {
                        name: "rebate-type",
                        option: {
                          value: "start",
                          title: "Pełna opłata startowa",
                        },
                      },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    }),
                    _c("panel-input-base-radio", {
                      attrs: {
                        name: "rebate-type",
                        option: { value: "mass", title: "Multi kod" },
                      },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "col-12 col-lg-8" }, [
                  _c("p", { staticClass: "rebates-form__hint" }, [
                    _vm._v(
                      " Wartość kodu rabatowego może być kwotowa lub likwidować opłatę startową. Kody rabatowe generowane są pulami. Określ wartość rabatu oraz ilość kodów. Do listy wygenerowanych kodów możesz dodawać kolejne pule z inną wartością rabatu. "
                    ),
                  ]),
                  _vm.hasCycle
                    ? _c("div", { staticClass: "rebates-cycle" }, [
                        _vm._v(" Generujesz kody dla zawodów cyklicznych."),
                        _c("br"),
                        _vm._v(
                          " Uczestnicy będą mogli użyć kodu w dowolnych zawodach w tym cyklu. "
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "rebates-generate__row" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "rebates-generate__amount",
                          class: { "is-disabled": _vm.form.type === "start" },
                        },
                        [
                          _c("p", { staticClass: "rebates-field-label" }, [
                            _c("span", [_vm._v("Rabat")]),
                            _c("span", [_vm._v("zł")]),
                          ]),
                          _c("panel-input-text", {
                            attrs: { hint: "0", error: _vm.errors.value },
                            model: {
                              value: _vm.form.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "value", $$v)
                              },
                              expression: "form.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "rebates-generate__count" },
                        [
                          _c("p", { staticClass: "rebates-field-label" }, [
                            _vm._v("Ilość"),
                          ]),
                          _c("panel-input-text", {
                            attrs: { hint: "0", error: _vm.errors.count },
                            model: {
                              value: _vm.form.count,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "count", $$v)
                              },
                              expression: "form.count",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "base-button",
                        {
                          staticClass: "rebates-generate__submit",
                          attrs: { btn1: "", disabled: _vm.generating },
                          on: { click: _vm.generate },
                        },
                        [_vm._v(" Wygeneruj kody ")]
                      ),
                    ],
                    1
                  ),
                  _vm.form.type === "mass"
                    ? _c("div", { staticClass: "rebates-generate__mass" }, [
                        _c(
                          "div",
                          { staticClass: "rebates-generate__max" },
                          [
                            _c("p", { staticClass: "rebates-field-label" }, [
                              _vm._v("Max. użyć"),
                            ]),
                            _c("panel-input-text", {
                              attrs: { hint: "1", error: _vm.errors.max_uses },
                              model: {
                                value: _vm.form.maxUses,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "maxUses", $$v)
                                },
                                expression: "form.maxUses",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "rebates-generate__date" },
                          [
                            _c("panel-input-date", {
                              attrs: {
                                label: "Ważny od",
                                placeholder: "Ważny od",
                                error: _vm.errors.valid_from,
                              },
                              model: {
                                value: _vm.form.validFrom,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "validFrom", $$v)
                                },
                                expression: "form.validFrom",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "rebates-generate__date" },
                          [
                            _c("panel-input-date", {
                              attrs: {
                                label: "Ważny do",
                                placeholder: "Ważny do",
                                error: _vm.errors.valid_to,
                              },
                              model: {
                                value: _vm.form.validTo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "validTo", $$v)
                                },
                                expression: "form.validTo",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.formError
                    ? _c("p", { staticClass: "rebates-form__error" }, [
                        _vm._v(_vm._s(_vm.formError)),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _vm.features.combine
              ? _c(
                  "panel-competition-form-box",
                  { staticClass: "rebates-form__box mab16" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12 col-lg-4" },
                      [
                        _c("p", { staticClass: "rebates-form__label" }, [
                          _vm._v("Sumowanie kodów rabatowych"),
                        ]),
                        _c("panel-input-base-radio", {
                          attrs: {
                            name: "rebates-combine",
                            option: {
                              value: "separate",
                              title: "Rabaty się nie sumują",
                            },
                          },
                          model: {
                            value: _vm.rebatesCombine,
                            callback: function ($$v) {
                              _vm.rebatesCombine = $$v
                            },
                            expression: "rebatesCombine",
                          },
                        }),
                        _c("panel-input-base-radio", {
                          attrs: {
                            name: "rebates-combine",
                            option: {
                              value: "sum",
                              title: "Rabaty się sumują",
                            },
                          },
                          model: {
                            value: _vm.rebatesCombine,
                            callback: function ($$v) {
                              _vm.rebatesCombine = $$v
                            },
                            expression: "rebatesCombine",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-12 col-lg-8" }, [
                      _c("p", { staticClass: "rebates-form__hint" }, [
                        _vm._v(
                          " Czy uczestnicy mają mieć możliwość wprowadzania wielu kodów rabatowych w koszyku? Jeśli suma rabatów przekroczy wysokość opłaty startowej, rabat będzie naliczany dla produktów wybranych w sklepie zawodów. "
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { ref: "rebatesTable", staticClass: "rebate-list-card" },
              [
                !_vm.hasSelection
                  ? _c("div", { staticClass: "rebate-stats" }, [
                      _c("div", { staticClass: "rebate-stats__box" }, [
                        _c("div", { staticClass: "rebate-stats__title" }, [
                          _vm._v("Kody rabatowe niezrealizowane"),
                        ]),
                        _c("div", { staticClass: "rebate-metrics" }, [
                          _c("div", { staticClass: "rebate-metric" }, [
                            _c("span", [_vm._v("Ilość")]),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.unusedStats.count)),
                            ]),
                          ]),
                          _c("div", { staticClass: "rebate-metric" }, [
                            _c("span", [_vm._v("Wartość")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.formatPrice(_vm.unusedStats.value))
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "rebate-stats__box" }, [
                        _c("div", { staticClass: "rebate-stats__title" }, [
                          _vm._v("Kody rabatowe zrealizowane"),
                        ]),
                        _c("div", { staticClass: "rebate-metrics" }, [
                          _c("div", { staticClass: "rebate-metric" }, [
                            _c("span", [_vm._v("Ilość")]),
                            _c("strong", [_vm._v(_vm._s(_vm.usedStats.count))]),
                          ]),
                          _c("div", { staticClass: "rebate-metric" }, [
                            _c("span", [_vm._v("Wartość")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.formatPrice(_vm.usedStats.value))
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "rebate-stats__box" }, [
                        _c("div", { staticClass: "rebate-stats__title" }, [
                          _vm._v("Filtr"),
                        ]),
                        _c("div", { staticClass: "rebate-filters" }, [
                          _c(
                            "div",
                            {
                              staticClass: "rebate-filter",
                              class: {
                                "rebate-filter--filled": _vm.filters.valueKey,
                              },
                            },
                            [
                              _vm.filters.valueKey
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "rebate-filter__clear",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "Wyczyść kwotę",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.filters.valueKey = null
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "far fa-times-circle",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _c("panel-input-select", {
                                attrs: {
                                  options: _vm.valueFilterOptions,
                                  label: "text",
                                  "track-by": "value",
                                  placeholder: "Kwota kodu",
                                  "hide-selected": false,
                                },
                                model: {
                                  value: _vm.valueFilterModel,
                                  callback: function ($$v) {
                                    _vm.valueFilterModel = $$v
                                  },
                                  expression: "valueFilterModel",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "rebate-filter",
                              class: {
                                "rebate-filter--filled": _vm.filters.status,
                              },
                            },
                            [
                              _vm.filters.status
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "rebate-filter__clear",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "Wyczyść status",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.filters.status = null
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "far fa-times-circle",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _c("panel-input-select", {
                                attrs: {
                                  options: _vm.statusFilterOptions,
                                  label: "text",
                                  "track-by": "value",
                                  placeholder: "Status",
                                  "hide-selected": false,
                                },
                                model: {
                                  value: _vm.statusFilterModel,
                                  callback: function ($$v) {
                                    _vm.statusFilterModel = $$v
                                  },
                                  expression: "statusFilterModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "rebate-stats rebate-stats--selection",
                        class: {
                          "rebate-stats--selection-no-share":
                            !_vm.features.share,
                        },
                      },
                      [
                        _c("div", { staticClass: "rebate-stats__box" }, [
                          _c("div", { staticClass: "rebate-stats__title" }, [
                            _vm._v("Wybrane"),
                          ]),
                          _c("div", { staticClass: "rebate-metrics" }, [
                            _c("div", { staticClass: "rebate-metric" }, [
                              _c("span", [_vm._v("Ilość")]),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.selectedStats.count)),
                              ]),
                            ]),
                            _c("div", { staticClass: "rebate-metric" }, [
                              _c("span", [_vm._v("Wartość")]),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatPrice(_vm.selectedStats.value)
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm.features.share
                          ? _c("div", { staticClass: "rebate-stats__box" }, [
                              _c(
                                "div",
                                { staticClass: "rebate-stats__title" },
                                [_vm._v("Oznacz")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "rebate-share",
                                  on: {
                                    "!click": function ($event) {
                                      return _vm.onSharePointer.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    "!keydown": function ($event) {
                                      return _vm.onShareKey.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "panel-input-checkbox",
                                    {
                                      attrs: {
                                        value: _vm.shareChecked,
                                        "checkbox-value": true,
                                        name: "rebate-share",
                                        variant: "white",
                                      },
                                    },
                                    [_vm._v(" Udostępniony ")]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "rebate-stats__box" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "rebate-stats__title rebate-stats__title--ghost",
                            },
                            [_vm._v("Akcje")]
                          ),
                          _c("div", { staticClass: "rebate-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "rebate-action",
                                attrs: { type: "button" },
                                on: { click: _vm.exportCsv },
                              },
                              [
                                _c("span", [_vm._v("CSV")]),
                                _c("i", {
                                  staticClass: "fas fa-external-link-alt",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "rebate-action",
                                attrs: { type: "button" },
                                on: { click: _vm.copyCodes },
                              },
                              [
                                _c("span", [_vm._v("Kopiuj")]),
                                _c("i", {
                                  staticClass: "fas fa-copy",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm.features.delete
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "rebate-action",
                                    attrs: { type: "button" },
                                    on: { click: _vm.deleteSelected },
                                  },
                                  [
                                    _c("span", [_vm._v("Usuń")]),
                                    _c("i", {
                                      staticClass: "fas fa-trash",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "rebate-action rebate-action--close",
                                attrs: { type: "button" },
                                on: { click: _vm.clearSelection },
                              },
                              [_vm._v(" Zamknij ")]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                _c(
                  "div",
                  { staticClass: "rebate-table-wrap" },
                  [
                    _c("base-table", {
                      staticClass: "rebate-table",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.tableItems,
                        "sort-column-default": 1,
                        "sort-reverse-default": false,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function ({ sort }) {
                            return [
                              _c(
                                "tr",
                                _vm._l(_vm.headers, function (header, column) {
                                  return _c(
                                    "th",
                                    {
                                      key: header.value,
                                      class: [
                                        `col-${header.value}`,
                                        {
                                          "is-static":
                                            header.value === "index" ||
                                            header.value === "select",
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          header.value !== "select" &&
                                            header.value !== "index" &&
                                            sort(column)
                                        },
                                      },
                                    },
                                    [
                                      header.value === "select"
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rebate-check rebate-check--header",
                                                on: {
                                                  "!click": function ($event) {
                                                    return _vm.toggleSelectAll.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "panel-input-checkbox",
                                                  {
                                                    attrs: {
                                                      value: _vm.selectAll,
                                                      "checkbox-value": true,
                                                      name: "rebate-select-all",
                                                      variant: "white",
                                                    },
                                                  },
                                                  [_vm._v("   ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              " " + _vm._s(header.text) + " "
                                            ),
                                            header.value === "addedDateDisplay"
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-list rebate-sort",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                    ],
                                    2
                                  )
                                }),
                                0
                              ),
                            ]
                          },
                        },
                        {
                          key: "body",
                          fn: function ({ displayedItems }) {
                            return _vm._l(displayedItems, function (item, row) {
                              return _c("tr", { key: item.id }, [
                                _c("td", { staticClass: "col-index" }, [
                                  _vm._v(_vm._s(row + 1) + "."),
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "col-addedDateDisplay" },
                                  [_vm._v(_vm._s(item.addedDateDisplay))]
                                ),
                                _c("td", { staticClass: "col-valueDisplay" }, [
                                  _vm._v(_vm._s(item.valueDisplay)),
                                ]),
                                _c("td", { staticClass: "col-code" }, [
                                  _c("span", { staticClass: "rebate-code" }, [
                                    _vm._v(_vm._s(item.code)),
                                  ]),
                                  item.usesDisplay
                                    ? _c(
                                        "span",
                                        { staticClass: "rebate-uses" },
                                        [_vm._v(_vm._s(item.usesDisplay))]
                                      )
                                    : _vm._e(),
                                ]),
                                _c("td", { staticClass: "col-playerName" }, [
                                  _vm._v(_vm._s(item.playerName)),
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "col-usedDateDisplay" },
                                  [_vm._v(_vm._s(item.usedDateDisplay))]
                                ),
                                _c("td", { staticClass: "col-statusLabel" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "rebate-status",
                                      class: item.statusClass,
                                    },
                                    [
                                      item.statusIcon
                                        ? _c("i", { class: item.statusIcon })
                                        : _vm._e(),
                                      _vm._v(
                                        " " + _vm._s(item.statusLabel) + " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("td", { staticClass: "col-select" }, [
                                  item.selectable
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "rebate-check",
                                          on: {
                                            "!click": function ($event) {
                                              return _vm.toggleRow(
                                                item.id,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "panel-input-checkbox",
                                            {
                                              attrs: {
                                                value: _vm.selectedIds.includes(
                                                  item.id
                                                ),
                                                "checkbox-value": true,
                                                name: `rebate-${item.id}`,
                                              },
                                            },
                                            [_vm._v("   ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                              ])
                            })
                          },
                        },
                        {
                          key: "no-results",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "rebate-empty" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.rebates.length
                                        ? "Nie znaleziono"
                                        : "Brak kodów rabatowych"
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c("modal", {
              ref: "deleteModal",
              staticClass: "rebate-delete-modal",
              attrs: { "body-class": "h-auto" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [_vm._v("Usuń wybrane kody rabatowe")]
                  },
                  proxy: true,
                },
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "rebate-delete-modal__body" }, [
                        _c("p", [
                          _vm._v(
                            "Czy na pewno, chcesz usunąć wybrane kody rabatowe?"
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            " Przy próbie skorzystania z usuniętego kodu uczestnik zostanie poinformowany, że kod jest nieaktywny. "
                          ),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "rebate-delete-modal__cancel",
                          attrs: { type: "button" },
                          on: { click: _vm.closeDeleteModal },
                        },
                        [_vm._v("Anuluj")]
                      ),
                      _c(
                        "base-button",
                        {
                          attrs: { btn1: "", disabled: _vm.deleting },
                          on: { click: _vm.confirmDelete },
                        },
                        [_vm._v("Usuń wybrane kody")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "admin-header__loading-state" }, [
        _vm._v(" Trwa wczytywanie "),
        _c("div", { staticClass: "mal15 lds-ellipsis" }, [
          _c("div"),
          _c("div"),
          _c("div"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }